document.addEventListener("DOMContentLoaded", function() {

  function moveDonation() {
    var donation = document.querySelector(".donation");
    var updateBtn = document.querySelector(".update-cart");

    if (donation && updateBtn) {
      updateBtn.parentNode.insertBefore(donation, updateBtn);
    }
  }

  // Run immediately
  moveDonation();

  // Easy Donation loads via AJAX, so run again after delay
  setTimeout(moveDonation, 800);
  setTimeout(moveDonation, 1500);
});